import { apiRequest } from '@/api/request.js'
export const getScoreInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/score/score_info',
    method: 'GET'
  })
}
export const refreshUserScore = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/score/update_user_score',
    method: 'GET'
  })
}
export const getUserAddress = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_addr',
    method: 'GET'
  })
}
export const listUserAddresses = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_addr/list',
    method: 'GET'
  })
}
export const listUserBalanceLogs = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_balance_log/page',
    method: 'GET'
  })
}
export const listUserCards = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/list',
    method: 'GET'
  })
}
export const listUserCardsByTelephone = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/listByTelephone',
    method: 'GET'
  })
}
export const getUserExtensionInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_extension/get_info',
    method: 'GET'
  })
}
export const getUserBalancePwdConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/get_user_balance_pwd_config',
    method: 'GET'
  })
}
export const getShopMemberLevelInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/get_shop_level_info',
    method: 'GET'
  })
}
export const getUserLevelTerm = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/get_user_level_term',
    method: 'GET'
  })
}
export const listLevelRightsByType = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/list_rights_by_level_type',
    method: 'GET'
  })
}
export const getUserMemberLevelInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/member_info',
    method: 'GET'
  })
}
export const listMemberLevelsByType = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/ua/list_level_by_type',
    method: 'GET'
  })
}
export const listShopLevelsByType = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/ua/list_shop_level_by_type',
    method: 'GET'
  })
}
export const getUserDetailInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/ma/user_detail_info',
    method: 'GET'
  })
}
export const listUserRechargeRecords = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_recharge/list',
    method: 'GET'
  })
}
export const listUserScoreLogs = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_score_log/page',
    method: 'GET'
  })
}
export const listScoreProdExchangeRecords = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_score_log/score_prod_page',
    method: 'GET'
  })
}
export const getCurrentUserInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/user_info',
    method: 'GET'
  })
}
export const getTotalWithdrawAmount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_withdraw/get_total_withdraw_amount',
    method: 'GET'
  })
}
export const listUserWithdrawCashPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_withdraw/page_date_user_withdraw_cash',
    method: 'GET'
  })
}
export const triggerCostPerPopup = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/ma/cost_per_popup/popup',
    method: 'POST'
  })
}
export const registerFreeShopMember = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/ma/shop_user_member/register_free_shop_member',
    method: 'POST'
  })
}
export const saveUserAddress = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_addr',
    method: 'POST'
  })
}
export const setPayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/set_pay_password',
    method: 'POST'
  })
}
export const updateUserAddress = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_addr',
    method: 'PUT'
  })
}
export const updatePayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/update_pay_password',
    method: 'POST'
  })
}
export const payWithUserBalance = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_balance/balance_pay',
    method: 'POST'
  })
}
export const payWithFlashUserBalance = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_balance/flash_balance_pay',
    method: 'POST'
  })
}
export const bindUserCard = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/bind',
    method: 'POST'
  })
}
export const payWithUserCard = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/pay',
    method: 'POST'
  })
}
export const payWithFlashUserCard = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/flash_pay',
    method: 'POST'
  })
}
export const buyVipMembership = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_level/buy_vip',
    method: 'POST'
  })
}
export const rechargeUserBalance = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_recharge/recharge',
    method: 'POST'
  })
}
export const applyUserWithdraw = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_withdraw/apply',
    method: 'POST'
  })
}
export const confirmUserWithdrawPay = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_withdraw/pay_confirm',
    method: 'POST'
  })
}
export const updateUserProfile = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/set_user_info',
    method: 'PUT'
  })
}
export const updateUserMobile = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/update_mobile',
    method: 'PUT'
  })
}
export const deleteUserCard = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/card/delete',
    method: 'DELETE'
  })
}
export const deleteUserAddress = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user_addr',
    method: 'DELETE'
  })
}
export const destroyUser = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_user/user/destroy_user',
    method: 'GET'
  })
}
